<template>
<section class="container">
  <section class="confirm_list">
    <section class="list_item">
      <p class="item_left">券类型</p>
      <p class="item_right">{{couponType}}</p>
    </section>
    <section class="list_item">
      <p class="item_left">券优惠</p>
      <p class="item_right">{{couponData}}</p>
    </section>
    <section class="list_item">
      <p class="item_left">单价</p>
      <p class="item_right">{{unitPrice | priceFormat}}元/张</p>
    </section>
    <section class="list_item border-bottom">
      <p class="item_left">数量</p>
      <p class="item_right">x{{number}}</p>
    </section>
    <section class="list_item list_last">
      <p class="item_left">需支付</p>
      <p class="item_right">¥{{unitPrice*number | priceFormat}}</p>
    </section>
  </section>
  <common-footer text="立即支付" @btnClick="btnClick"></common-footer>
</section>
</template>
<script>
import {mapState} from 'vuex'
import {} from '../../utils/api'
import util from '../../utils/util'
import CommonFooter from '../../components/footer'
import ping from '../../utils/pingpay.js'
export default {
  name: 'confirmOrder',
  props: {

  },
  components: {
    CommonFooter
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
      couponType:'',
      couponData:'',
      unitPrice:'',
      number:'',
      canPay:true
    }
  },
  created(){
    this.couponType = this.$route.query.couponType || '';
    this.couponData = this.$route.query.couponData || '';
    this.unitPrice = this.$route.query.unitPrice || '';
    this.number = this.$route.query.number || '';
  },
  methods:{
    btnClick () {
      if(!this.canPay){return;}
      util.showLoading()
      this.canPay = false;
      let params = {
        orderNo: this.$route.query.orderNo,
        repairNo: '', // "报修单号",
        bussinessType:"7",//会议室1,活动2,租赁账单3,物业报修4,保洁服务5,送水服务6,临时停车7
        feeCode:this.$route.query.parkHeaderId,
        // payType: '5', // "支付类型 0微信，1支付宝, 4万生活, 5,ping++"
        channel: 'wx_pub' // 渠道名
      };
      ping(
        params,
        '',
        res => {
          console.log(res);
          this.$store.commit("isChange",true)
          this.$router.replace(`/successPage?title=购买成功&desc=停车券已购买成功，快去派券吧~&come=parkingCoupon`)
        },
        () => {
          this.canPay = true;
        },
        () => {
          this.canPay = true;
        }
      );
      setTimeout(()=>{
        this.canPay = true
      },1000)
    },
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
  background:#eee;
}
.confirm_list{
  margin:20px 20px 120px;
  background:rgba(255,255,255,1);
  border-radius:8px;
  padding:40px 40px 0;
  .list_item{
    .flex();
    padding-bottom: 40px;
    .item_left{
      width:160px;
      font-size:30px;
      color:rgba(102,102,102,1);
      line-height:42px;
    }
    .item_right{
      flex:1;
      white-space: nowrap;
      font-size:30px;
      color:rgba(51,51,51,1);
      line-height:42px;
    }
  }
  .list_last{
    justify-content: space-between;
    height:130px;
    align-items: center;
    padding-bottom: 0;
    .item_left{
      font-size:36px;
      color:#333;
    }
    .item_right{
      font-size:36px;
      text-align: right;
      color:#FD001B;
    }
  }
}
</style>
